import BaseAttribute, { AttributeExport, AttributeExportTypes } from './baseAttribute';
import { Category } from '../character/allValues';

export interface DiceAttributeExport extends AttributeExport {
  dice: number;
  modifier: number;
}

export default class DiceAttribute extends BaseAttribute {
  public category: Category = Category.Attribute;
  public numDice: number = 0;
  public numBonus: number = 0;
  public constructor(name: string) {
    super(name);
  }

  public setValue(dices: number, bonus: number) {
    this.numDice = dices;
    this.numBonus = bonus;
  }

  public getClone() {
    const clone = new DiceAttribute(this.name);
    clone.numDice = this.numDice;
    clone.numBonus = this.numBonus;
    return clone;
  }

  public toString() {
    return this.numDice + 'W +' + this.numBonus;
  }

  public export(): DiceAttributeExport {
    return {
      name: this.name,
      type: AttributeExportTypes.Dice,
      dice: this.numDice,
      modifier: this.numBonus,
      abbreviation: this.abbreviation,
    };
  }
}
